; (function () {
    var

        _$wrapper = null,


        //set to true when a popup is open, can't open another
        _popup_open = false,

        //package wizard
        _current_step = 1,
        _num_steps,
        _done = false;



        //
        // init 
        //
    init = function () {
        _$wrapper = $('.layout-package-list');

        if (_$wrapper.length > 0) {

            disableEnterKey();
            setupAddPackage();
            setupDeletePackage();
            // setupCopyPackage();
            // setupSelectedPackage();
        }
    },

        disableEnterKey = function () {
            document.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                }
            });
        },

        //
        // setup the add package button
        //
        setupAddPackage = function () {
            $('#lnkAddPackage').on('click', function () {

                $('#lnkAddPackage .icon').toggleClass('icon-plus').toggleClass('icon-spinner');

                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(
                        '/package/packageWizard',
                        function (html) {
                            delta.popup.open({
                                type: 'generic',
                                title: 'Add Package',
                                content: html,
                                css: 'popup-move',
                                cssClass: 'modal-newpackage-wizard',
                                afterOpen: function ($popup) {
                                    setupPackageWizard();
                                    delta.utility.setupDatePicker($popup);
                                    _popup_open = false;
                                    $('#lnkAddTemplate .icon').toggleClass('icon-plus').toggleClass('icon-spinner');
                                },
                                buttons: [
                                    {
                                        text: 'Previous',
                                        isPrimary: false,
                                        leftAlign: true
                                    },
                                    {
                                        text: 'Next',
                                        isPrimary: true,
                                        leftAlign: true
                                    },
                                    {
                                        text: 'Cancel',
                                        isPrimary: false,
                                        callback: function ($popup) {
                                            delta.popup.close($popup);
                                            _current_step = 1,
                                                _done = false
                                        }
                                    },
                                    {
                                        text: 'Finish',
                                        isPrimary: false,
                                        callback: function ($popup) {
                                            $('#autoPopup_1 .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3 fa-spinner"></i>');
                                            var formData = new FormData();
                                            $popup.find('input, select').each(function () {
                                                var name = $(this).attr('name');
                                                var value = $(this).val();
                                                formData.append(name, value);
                                            });
                                            var reports = $('.selected-report').map(function () {
                                                return {
                                                    ReportID: $(this).data('id'),
                                                };
                                            }).get();
                                            reports.forEach(function (rpt, index) {
                                                formData.append(`Reports[${index}].ReportID`, rpt.ReportID);
                                                formData.append(`Reports[${index}].SortOrder`, index + 1)
                                            });

                                            delta.ajax.postFormData(
                                                '/package/save',
                                                formData,
                                                function (result) {
                                                    delta.popup.close($popup);
                                                    window.location = result.redirectURL;
                                                }
                                            );

                                            return false;
                                        }
                                    },
                                ],
                            });

                        }
                    );
                }
            });
        },


        setupPackageWizard = function () {
            $(".title-template-step").addClass("show active");
            _num_steps = $('.container-steps .wizard-step').length;

            //Assign consecutive IDs to all available tabs, which are then used for navigation purposes.
            const visibleSteps = document.querySelectorAll('.container-steps .wizard-step');
            Array.from(visibleSteps).map((step, index) => {
                step.id = `StepWizard${index + 1}`;
            });

            const visibleTabSteps = document.querySelectorAll('.tab-content .tab-pane');
            Array.from(visibleTabSteps).map((step, index) => {
                step.id = `StepTab${index + 1}`;
            });
            packageWizardButtons();
            packageWizardTitleTemplate();
            packageWizardSelectReports();

            showPackageWizardStep(1);
        },

        packageWizardButtons = function () {
            const $prevBtn = $(".modal-newpackage-wizard button[data-btn-index='0']");
            const $nextBtn = $(".modal-newpackage-wizard button[data-btn-index='1']");
            const $finishBtn = $(".modal-newpackage-wizard button[data-btn-index='3']");

            $($prevBtn).prop("disabled", true);
            $($finishBtn).prop("disabled", true);


            $($prevBtn).on("click", function () {
                const incomplete = validatePackageWizardStep('prev');
                if (!incomplete && _current_step > 1) {
                    showPackageWizardStep(+_current_step - 1);
                }
            });

            $($nextBtn).on("click", function () {
                const incomplete = validatePackageWizardStep('next');
                if (!incomplete && _current_step < _num_steps) {
                    showPackageWizardStep(_current_step + 1);
                }
                if (_current_step === _num_steps) {
                    showWizardSummary();
                }

            });


        },


        packageWizardTitleTemplate = function () {
            const $finishBtn = $(".modal-newpackage-wizard button[data-btn-index='3']");

            $("#Title").on("input paste cut change keyup", function () {
                ttStepValid();
                updatePackageWizardSummary();
            });

            $('#TemplateID').on('change', function () {
                ttStepValid();
                updatePackageWizardSummary();
            })

            var ttStepValid = function () {
                if ($('#Title').val().trim() === "" || $("#TemplateID").val() == "") {
                    $($finishBtn).prop("disabled", true);
                } else if (_done) {
                    $($finishBtn).prop("disabled", false);
                }
            }

        },


        packageWizardSelectReports = function () {
            const $finishBtn = $(".modal-newpackage-wizard button[data-btn-index='3']");
            var $checkboxes = $('.report-select');
            $checkboxes.on('click', function () {
                // enable/disable Finish btn
                var isChecked = $checkboxes.is(':checked');
                if (!isChecked) {
                    $($finishBtn).prop("disabled", true);
                } else if (_done) {
                    $($finishBtn).prop("disabled", false);
                }
                // create draggable elements
                $('#report-order').empty();
                $('.report-select:checked').each(function () {
                    var checkboxId = $(this).attr('id');
                    var label = $('label[for="' + checkboxId + '"]').text();
                    var pillClasses = "badge bg-secondary-custom text-dark text-left rounded-pill mb-2 ps-2 draggable selected-report";
                    var draggablePill = $(`<div data-id="${checkboxId}" class="${pillClasses}">${label}</div>`);
                    $('#report-order').append(draggablePill);
                });
                updatePackageWizardSummary();
                $("#report-order").sortable({
                    placeholder: 'ui-state-highlight',
                    //axis: 'y',
                    containment: ".ui-sortable",
                    tolerance: "pointer",
                    start: function () {
                        $('.modal-body').css('overflow', 'hidden');
                    },
                    stop: function () {
                        $('.modal-body').css('overflow', '');
                        updatePackageWizardSummary();
                    }
                });
                $("#report-order").disableSelection();

            })
        }


        validatePackageWizardStep = function (action) {
            let incomplete = false;
            $('.text-danger').hide();

            if (_current_step === 1) {
                if ($('#Title').val().trim() === "") {
                    if (action === 'next') {
                        $('#Title').after('<label class="required-label text-danger mt-1">Package title is required</label>');
                        $('#Title').trigger('focus');
                    }
                    incomplete = true;
                }

                if($('#TemplateID').val() === "") {
                    if (action === 'next') {
                        $('#TemplateID').after('<label class="required-label text-danger mt-1">Package template is required</label>');
                        $('#TemplateID').trigger('focus');
                    }
                    incomplete = true;
                }

                if (incomplete == true) {
                    $("#StepWizard2 .wizard-step-circle").removeClass('wizard-step-completed');
                    // $("#StepWizard2 .fa-check").hide();
                }
                    
            }

            if (_current_step === 2) {
                var checkboxes = $('.report-select');
                var isChecked = checkboxes.is(':checked');
                if (!isChecked) {
                    if (action === 'next' || action === 'prev') {
                        $('#list-report-select').after('<label class="required-label text-danger mt-1">At least one report required to build package.</label>');
                    }
                    incomplete = true;
                }
            }

            
 
            return incomplete;
        },



        showPackageWizardStep = function (step) {
            const $prevBtn = $(".modal-newpackage-wizard button[data-btn-index='0']");
            const $nextBtn = $(".modal-newpackage-wizard button[data-btn-index='1']");
            const $finishBtn = $(".modal-newpackage-wizard button[data-btn-index='3']");
            const $currentStepWizard = $("#StepWizard" + step);
            const $currentStepCircle = $currentStepWizard.find('.wizard-step-circle');

            $(".tab-pane, .wizard-step-circle").removeClass("show active wizard-step-active");

            $("#StepTab" + step).addClass("show active");
            $currentStepWizard.addClass("show active");

            if (step > 1) {
                $("#StepWizard" + (+step - 1) + ' .wizard-step-circle').addClass('wizard-step-completed');
                // $("#StepWizard" + (+step - 1) + ' .fa-check').show();
            }


            $prevBtn.prop("disabled", step === 1);
            $nextBtn.prop("disabled", step === _num_steps);

            if (_num_steps === step) {
                $finishBtn.addClass("btn-success").removeClass("btn-light").prop("disabled", false);
                // $("#StepWizard" + (step) + ' .fa-check').show();
                _done = true;
            }

            if (step === _num_steps) {
                $currentStepCircle.addClass('wizard-step-completed wizard-step-active');
            } else {
                $currentStepCircle.addClass('wizard-step-active');
            }

            $('.modal-newpackage-wizard .tbl-steps td').each(function(idx) {        
                var $td = $(this);
                var $cir = $td.find('.wizard-step-circle');
    
                if ($cir.hasClass('wizard-step-completed')) {
                    $td.addClass('td-completed');
                } else {
                    $td.removeClass('td-completed');
                }
    
                if ($cir.hasClass('wizard-step-active')) {
                    $td.addClass('td-active');
                } else {
                    $td.removeClass('td-active');
                }
    
                $cir.html(idx+1);
            });
    

            _current_step = step;
        },


        updatePackageWizardSummary = function () {
            
            // title
            var title = $('#Title').val();
            $('#summary-package-title').text(title);

            //template
            var template = $('#TemplateID option:selected').text();
            $('#summary-package-template').text(template);

            //reports
            $('#summary-reports').empty();
            $('#report-order .draggable').each(function () {
                var textValue = $(this).text();
                $('#summary-reports').append(`<li>${textValue}</li>`);
            });


        },



        //
        // soft delete a package
        //
        setupDeletePackage = function () {
            _$wrapper.on('click', '.lnk-delete', function () {
                var $a = $(this);
                var packageID = $a.attr('data-package-id');
                var tableRow = $a.closest('tr');
                var title = tableRow.find('td').eq(0).find('span').text();

                delta.popup.open({
                    type: 'confirm',
                    title: 'Delete Package',
                    content: 'Are you sure you want to delete the <b>' + title + '</b>  package?',
                    okButtonText: 'Delete Package',
                    okCallback: function ($popup) {
                        $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');
                        delta.ajax.get(
                            '/package/delete?packageID=' + packageID,
                            function (html) {
                                document.location.reload();
                            }
                        );

                        return false;
                    }
                });
            });

        },



        // setupSelectedPackage = function () {
        //     _$wrapper.on('click', '.package-list-item', function () {
        //         var $a = $(this);
        //         var packageID = $a.attr('package-list-package-id');
        //         $("a[package-list-package-id='" + packageID + "']").hide();
        //         $("i[package-list-package-id-loading-image='" + packageID + "']").show();
        //         $("a[package-list-package-id-loading-link='" + packageID + "']").show();
        //     });
        // },



        dummy = function () { };

    $(document).ready(init);

}());







